import React, { useEffect, useState } from 'react'
import Questions from './data/Questions'
import TextView from './TextView'
import './App.css'

const App = () => {

  const [text, setText] = useState('');
  const [gameStarted, setGameStarted] = useState(false);

  const max = Questions.length
  
  const keyListener = (event) => {
    const eventKey = event.key

    if (eventKey==='ArrowRight'){
      const randomIndex = Math.floor(Math.random() * (max));
      setText(Questions[randomIndex])

      if (!gameStarted){
        setGameStarted(true)
      }
    }
  }

  const buttonClick = () => {

    const randomIndex = Math.floor(Math.random() * (max));
    setText(Questions[randomIndex])

    if (!gameStarted){
      setGameStarted(true)
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', keyListener)

    return () => {
      window.removeEventListener('keydown', keyListener)
    }
  })

  document.body.style.backgroundColor = "#ffcccc";

  return (
    <div className="ui container">
      <div className="ui sizer vertical segment">
        <div className="ui huge header">qq;</div>
        {gameStarted ?
          <TextView text={text}/>
        : <div className="text-content">
            <h3>qq; quick question</h3>
            <p>Questions to ask friends, partners, or anyone.</p>
            Click <i>Next</i> or press <i className="right arrow icon"></i> on the keyboard.
          </div>
        }
        <div className="button-content">
          <button 
            className="ui right labeled icon button"
            onClick={buttonClick}>
            <i className="right arrow icon"></i>
              Next
          </button> 
        </div>
        <div className="bottom">
          qq; quick question
        </div>
      </div>
    </div>
  );
}

export default App;
